/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiEmployeesIdCvSummaryQueryResponse,
  GetApiEmployeesIdCvSummaryPathParams,
} from '../models/GetApiEmployeesIdCvSummary.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiEmployeesIdCvSummaryQueryResponseSchema } from '../zod/getApiEmployeesIdCvSummarySchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiEmployeesIdCvSummaryQueryKey = (
  id: GetApiEmployeesIdCvSummaryPathParams['id'],
) => [{ url: '/api/employees/:id/cv/summary', params: { id: id } }] as const;

export type GetApiEmployeesIdCvSummaryQueryKey = ReturnType<
  typeof getApiEmployeesIdCvSummaryQueryKey
>;

/**
 * {@link /api/employees/:id/cv/summary}
 */
export async function getApiEmployeesIdCvSummary(
  id: GetApiEmployeesIdCvSummaryPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiEmployeesIdCvSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/employees/${id}/cv/summary`,
    ...requestConfig,
  });
  return getApiEmployeesIdCvSummaryQueryResponseSchema.parse(res.data);
}

export function getApiEmployeesIdCvSummaryQueryOptions(
  id: GetApiEmployeesIdCvSummaryPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiEmployeesIdCvSummaryQueryKey(id);
  return queryOptions<
    GetApiEmployeesIdCvSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiEmployeesIdCvSummaryQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiEmployeesIdCvSummary(id, config);
    },
  });
}

/**
 * {@link /api/employees/:id/cv/summary}
 */
export function useGetApiEmployeesIdCvSummary<
  TData = GetApiEmployeesIdCvSummaryQueryResponse,
  TQueryData = GetApiEmployeesIdCvSummaryQueryResponse,
  TQueryKey extends QueryKey = GetApiEmployeesIdCvSummaryQueryKey,
>(
  id: GetApiEmployeesIdCvSummaryPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiEmployeesIdCvSummaryQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiEmployeesIdCvSummaryQueryKey(id);

  const query = useQuery(
    {
      ...getApiEmployeesIdCvSummaryQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
